module.exports = __webpack_public_path__ + "static/media/Heart_diffuse_N.a27e31df.jpg";